import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import dompurify from "isomorphic-dompurify";
import styles from "./Promotions.module.scss";
const { sanitize } = dompurify;
export const Promotions = forwardRef(({ discounts = [], legalDisclaimer }, ref) => {
    return (_jsx("div", { className: styles.promotionDisclaimer, ref: ref, "data-testid": "promotions", children: _jsxs("div", { className: styles.promotionDisclaimerInner, children: [discounts.length > 0 && (_jsx("div", { className: styles.promotionDisclaimerContent, children: discounts.map((discount, index) => (_jsx("span", { children: discount.priceDisclaimer }, `${index}-${discount.priceDisclaimer}`))) })), legalDisclaimer && (_jsx("span", { className: styles.legalDisclaimer, dangerouslySetInnerHTML: {
                        __html: sanitize(legalDisclaimer),
                    } }))] }) }));
});
Promotions.displayName = "Promotions";
//# sourceMappingURL=Promotions.js.map